import { ModalBody } from './modal-body';
import { ModalHeader } from './modal-header';
import { PartLookUpResult } from 'api/generated';
import { ToggleState } from 'hooks/use-toggle';
import { FC, useEffect } from 'react';

type Props = {
  state: ToggleState<PartLookUpResult[]>;
  onSelectPart?: (part: PartLookUpResult) => void;
};

export const SelectPartModal: FC<Props> = (props) => {
  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, []);

  return (
    <>
      <div className="modal fade show d-block" id="kt_modal" role="dialog" tabIndex={-1} aria-modal="true">
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered modal-lg">
          {/* begin::Modal content */}
          <div className="modal-content">
            <ModalHeader onClose={() => props.state.close()} />
            {/* begin::Modal body */}
            <div className="modal-body scroll-y pb-8 pt-0">
              <ModalBody
                parts={props.state.data ?? []}
                onSelectPart={props.onSelectPart}
                onClose={() => props.state.close()}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};
